import { onApiError } from "../error";
import { currentLocale } from "../locale";
import { get, post } from "./client";

/**
 * @param {string} field
 * @param {string} target
 * @returns {Promise<User[]>}
 */
async function findUser(field, target) {
	const res = await get(`/users?field=${field}&target=${target}`);
	if (!res.ok) throw await onApiError(res);
	return res.json();
}

/**
 * @typedef {Object} CreateAccountParams
 * @property {string} email
 * @property {string} password
 * @property {string} country
 * @property {string} name
 * @property {string} addr1
 * @property {string} addr2
 * @property {string} postalCode
 * @property {string} town
 * @property {string} vatin
 */

/**
 * @param {CreateAccountParams} args
 */
async function postUser(args) {
	const res = await post("/users", {
		body: JSON.stringify({
			Email: args.email,
			Password: args.password,
			Country: args.country,
			Locale: currentLocale,
			Name: args.name,
			Addr1: args.addr1,
			Addr2: args.addr2,
			PostalCode: args.postalCode,
			Town: args.town,
			Vatin: args.vatin,
		}),
	});

	if (!res.ok) throw await onApiError(res);
}

export { findUser, postUser };
